import Block from './Block'
import PropertyListerView from './Finder/property-lister/view'
import {imagesToSvg} from '../utils'
import HTML from '../html'
import sharedData from '../shared-data'

class SearchResultsBuilder {

    constructor() {
        this.propertyListerView = new PropertyListerView(this)
    }

    __render__page(data) {
        return HTML('a')
            .classes(`scard ${data.type}`)
            .attr({ href: data.permalink })
            .append(
                HTML('div')
                    .classes('scard__thumb')
                    .attr({ style: `background-image: url("${data.image}")` }),
                HTML('h3')
                    .classes('scard__title scard__text')
                    .content(data.title),
                HTML('div')
                    .classes('scard__descr scard__text')
                    .content(data.description),
            )
    }

    __render__news(data) {
        return this.__render__page(data)
    }

    __render__person(person) {
        return HTML('div')
            .classes('scard scard--person')
            .append(
                HTML('div')
                    .classes('scard__thumb')
                    .attr({ style: `background-image: url("${person.portrait}")` }),
                HTML('h3')
                    .classes('scard__title scard__text')
                    .content(person.name),
                HTML('div')
                    .classes('scard__descr scard__text')
                    .content(person.position),
                HTML('a')
                    .classes('email scard__text')
                    .attr({ href: `mailto:${person.email}` })
                    .content(person.email),
                HTML('a')
                    .classes('phone scard__text')
                    .attr({ href: `tel:${person.phone_numeric}` })
                    .content(person.phone),
            )
    }

    __render__document(data) {
        return HTML('a')
            .classes('scard scard--document')
            .attr({
                href: data.permalink,
                target: '__blank',
            })
            .append(
                HTML('div')
                    .classes('scard__thumb')
                    .append(
                        HTML('i').classes('fa fa-file-o'),
                    ),
                HTML('h3')
                    .classes('scard__title scard__text')
                    .content(data.title),
                HTML('p')
                    .classes('scard__subtitle scard__text')
                    .content(data.propName),
            )
    }

    __render__projekt(data) {
        return this.propertyListerView.projektCard(data)
    }

    __render__objekt(data) {
        return this.propertyListerView.objektCard(data)
    }

    __render__all(data) {
        var subdata = data.results[0]
        var sections = []

        for (let prop in subdata) {
            if (subdata.hasOwnProperty(prop)) {
                var props = []
                props = subdata[prop].results.map(
                    c => HTML('div')
                        .classes('sres__results__result')
                        .append(
                            this['__render__' + subdata[prop].type_slug] !== 'undefined'
                            ? this['__render__' + subdata[prop].type_slug](c)
                            : null,
                        ),
                )
                sections.push(
                    HTML('div')
                        .classes('sres__sectioned')
                        .append(
                            HTML('h2')
                                .classes('sres__sectioned__title')
                                .content(subdata[prop].title),
                            HTML('div')
                                .classes('sres__results list-mode')
                                .append(props),
                        ),
                )
            }
        }

        return sections
    }

    _block(data) {
        if (data.type_slug === 'all') {
            return this.__render__all(data)
        }
        return !data.results ? null : [
            HTML('div')
                .classes('sres__results list-mode')
                .append(
                    data.results.map(
                        c => HTML('div').classes('sres__results__result').append(
                            this['__render__' + data.type_slug] !== 'undefined'
                            ? this['__render__' + data.type_slug](c)
                            : null,
                        ),
                    ),
                ),
        ]
    }

    build(payload) {
        return payload
               ? HTML('div')
                   .classes('sres')
                   .append(
                       payload.results.length > 0
                       ? this._block(payload)
                       : HTML('h2').classes('nothing-found').content('Inget hittat'),
                   )
                   .render()
               : ''
    }

    buildError(message = 'Tyvärr fanns en fel') {
        return HTML('div')
            .classes('sres')
            .append(
                HTML('h2')
                    .classes('error-message')
                    .content(message),
            )
            .render()
    }
}

class CirclePreloader {
    constructor(root) {
        this.root = root
        this.circle = root.find('circle')
        this.length = 100
        this.intval = null
        this.percent = 0

        this.updateLength()
        this.offsetDash(0)
    }

    updateLength() {
        this.length = Number.parseInt(this.circle.attr('r')) * Math.PI * 2
        this.circle.css({
            strokeDasharray: this.length,
        })
        return this
    }

    offsetDash(percent) {
        this.percent = percent
        this.updateLength()
        this.circle.css({
            strokeDashoffset: this.length * (1 - this.percent / 100),
        })
        return this
    }

    show() {
        this.root.addClass('visible')
        this.intval = setInterval(() => {
            this.offsetDash(this.percent + (Math.random() * ((100 - this.percent) / 50)))
        }, 300)
        return this
    }

    hide() {
        this.root.removeClass('visible')
        this.offsetDash(0)
        window.clearInterval(this.intval)
        return this
    }
}


class SearchBox extends Block {

    constructor(blockRoot) {
        super(blockRoot)

        this.builder = new SearchResultsBuilder()
        this.events = {}

        this.fullscreen = false

        this.wrapper = this.root.find('.main-search')
        this.form = this.wrapper.find('.main-search__form')
        this.close = this.wrapper.find('.main-search__close')
        this.input = this.form.find('.main-search__input')
        this.button = this.form.find('.main-search__button')
        this.content = this.wrapper.find('.main-search__content')
        this.typesRoot = this.wrapper.find('.main-search__types')
        this.criteriaRoot = this.wrapper.find('.main-search__criteria')
        this._useCriteria = false

        this.preloader = new CirclePreloader(this.wrapper.find('.main-search__preloader'))

        window.circle = this.preloader

        this.transitionSpeed = 400
        this.queryTypes = sharedData.searchQueryTypes
        this.queryType = this.queryTypes[0]
        this.searchCriteria = {
            slug: '',
            name: '',
        }

        this.locked = false
        this.searchQuery = ''

        this._bindUI()
        this._initTypes()
    }

    isFullscreen() { return this.fullscreen }

    isMobile() { return window.innerWidth <= 900 }

    _initCriteria(type, typeButton) {
        if (type.criteria && type.criteria instanceof Array) {

            var buttons,
                container = HTML('div')
                    .classes('main-search__criteria__list')
                    .append(HTML('p').classes('criteria-helper').content('Sök kriterier:'))

            if (this._useCriteria) {
                buttons = type.criteria.map((c, j) => {
                    return HTML('a')
                        .classes('criteria-link')
                        .content(c.name)
                        .attr({ href: '#' })
                        .mutate(element => {
                            if (j === 0) {
                                this.setSearchCriteria(c)
                                $(element).addClass('active')
                            }
                        })
                        .on('click', (event, element) => {
                            event.preventDefault()
                            this.setSearchCriteria(c)
                            $(element).addClass('active').siblings().removeClass('active')

                            if (!this.isMobile()) {
                                this.search()
                            }
                        })
                })

                $(typeButton).on('click', event => {
                    this.setSearchCriteria(type.criteria[0])
                    buttons.map(b => b.element.classList.remove('active'))
                    buttons[0].element.classList.add('active')
                    $(container.element).addClass('visible').siblings().removeClass('visible')
                })

            } else {

                buttons = type.criteria.map((c, j) => {
                    return HTML('span')
                        .classes('criteria-link')
                        .content(c.name)
                        .render()
                })

                $(typeButton).on('click', event => {
                    $(container.element).addClass('visible').siblings().removeClass('visible')
                })
            }

            container.append(buttons)
            this.criteriaRoot.append(container.render())
        }
    }

    _initTypes() {
        let buttons = this.queryTypes.map((t, i) => {
            return HTML('a')
                .classes('main-search__types__type')
                .content(t.name)
                .attr({ href: '#' })
                .mutate(element => {
                    this._initCriteria(t, element)
                    if (i === 0) {
                        this.setQueryType(t)
                        $(element).addClass('active')
                    }
                    $(element).on('click', event => {
                        event.preventDefault()
                        if (!t.criteria || !(t.criteria instanceof Array)) {
                            this.criteriaRoot.children().removeClass('visible')
                        }
                        this.setQueryType(t)
                        $(element).addClass('active').siblings().removeClass('active')

                        if (!this.isMobile()) {
                            this.search()
                        }
                    })
                })
                .render()
        })

        this.typesRoot.append(buttons)

        let sliderInitiated = false

        let initSlider = () => {
            if (sliderInitiated) {
                return
            }
            this.typesRoot.slick({
                dots: false,
                arrows: true,
                infinite: true,
                autoplay: false,
            })
            this.typesRoot.on('afterChange', (slick, slide) => {
                var i = slide.getCurrent()
                var element = slide.$slides.eq(i)
                element.trigger('click')
            })
            sliderInitiated = true
        }

        let destroySlider = () => {
            if (!sliderInitiated) {
                return
            }
            this.typesRoot.slick('unslick')
            sliderInitiated = false
        }

        let resolveSlider = () => {
            window.innerWidth <= 900 ? initSlider() : destroySlider()
        }

        resolveSlider()

        $(window).on('resize', event => resolveSlider())
    }

    _bindUI() {

        this.form.on('submit', event => {
            event.preventDefault()
            this.search()
        })

        this.input.on('click', event => {
            if (!this.isFullscreen()) {
                this.engageFullscreen().search()
            }
        })

        this.close.on('click', event => {
            event.preventDefault()
            this.discardFullscreen()
        })
    }

    _clearInput() {
        this.input.val('')
        return this
    }

    _clearContent() {
        this.content.empty()
        return this
    }

    _clear() {
        this._clearInput()._clearContent()
        return this
    }

    _fillContent(content) {
        this._clearContent()
        if (content) {
            this.content.append(content)
        }
        imagesToSvg(this.content.find('.replace-with-svg'))
        return this
    }

    _showPreloader() {
        this.preloader.show()
        return this
    }

    _hidePreloader(callback) {
        this.preloader.offsetDash(100)
        setTimeout(() => {
            this.preloader.hide()
            setTimeout(() => {
                if (typeof callback === 'function') {
                    callback()
                }
            }, 200)
        }, 300)
        return this
    }

    _updatePreloader(percent = 0) {
        this.preloader.offsetDash(percent)
        return this
    }

    _doOnFailure(message = 'Tyvärr fanns det ett fel vid sökning.') {
        this._hidePreloader(() => {
            this._fillContent(this.builder.buildError(message))
        })
        this.unlock()
    }

    _doRequest(query, callback, queryType = this.queryType, searchCriteria = this.searchCriteria) {
        this.lock()
        this._showPreloader()
        var xhr = $.ajax({
            url: ajaxurl,
            data: {
                action: 'searchCredentia',
                query: query,
                type: queryType.slug,
                useCriteria: this._useCriteria,
                criteria: searchCriteria.slug,
            },
            timeout: 45000,
            beforeSend: jsXHR => {
                this._updatePreloader(24)
            },
            success: data => {
                // Check if there was change in input
                // while request was processing on server
                if (this.searchQuery !== query
                    || this.searchCriteria.slug !== searchCriteria.slug
                    || this.queryType.slug !== queryType.slug) {
                    // If there was a change, do another request
                    // without displaying it
                    this._doRequest(this.searchQuery, callback, this.queryType, this.searchCriteria)
                    return false
                }
                if (data.success && data.payload) {
                    this._hidePreloader(() => callback(data.payload))
                }
            },
            complete: (jqXHR, status) => {
                if (status === 'timeout') {
                    this._doOnFailure('Tyvärr, sök tog för mycket tid och avslutades.')
                } else if (status !== 'success') {
                    this._doOnFailure()
                }
                if (this.searchQuery === query) {
                    this.unlock()
                }
            },
            fail: () => {
                this._doOnFailure()
            },
        })
        return this
    }

    lock() {
        this.root.addClass('locked')
        this.locked = true
        return this
    }

    unlock() {
        this.root.removeClass('locked')
        this.locked = false
        return this
    }

    isLocked() { return this.locked }

    engageFullscreen() {
        this._clear().__executeEvents('fullscreen:start')
        this.root.addClass('visible').removeClass('hidden')
        this.input.trigger('focus')
        this.fullscreen = true
        setTimeout(() => {
            $('body > *').not(this.root).addClass('search-background')
            this.root.addClass('blur-ready')
        }, this.transitionSpeed)
        return this
    }

    discardFullscreen() {
        this.root.removeClass('blur-ready')
        setTimeout(() => {
            this.root.removeClass('visible').addClass('hidden')
            this.input.val('')
            $('body > *').not(this.root).removeClass('search-background')
            setTimeout(() => {
                this._clear().__executeEvents('fullscreen:end')
                this.fullscreen = false
            }, this.transitionSpeed)
        }, this.transitionSpeed)
        return this
    }

    setQueryType(type) {
        this.queryType = type
        return this
    }

    currentSearchCriteria() {
        return this.searchCriteria
    }

    setSearchCriteria(criteria) {
        this.searchCriteria = criteria
        return this
    }

    searchFor(query) {
        this._clearContent()
        this._doRequest(query, payload => {
            this._fillContent(this.builder.build(payload))
        })
        return this
    }

    search() {
        this.searchQuery = this.input.val()

        if (this.isLocked()) {
            return this
        }

        if (this.searchQuery.length > 1) {
            this.searchFor(this.searchQuery)
        } else {
            this._clearContent()
        }
        return this
    }

    __executeEvents(name, ...args) {
        if (this.events[name] instanceof Array) {
            this.events[name].map(event => event(this, args))
        }
    }

    on(name, callback) {
        if (typeof name !== 'string' || typeof callback !== 'function') {
            return
        }
        if (typeof this.events[name] === 'undefined') {
            this.events[name] = []
        }
        this.events[name].push(callback)
        return this
    }
}


export default class Header extends Block {

    constructor(blockRoot) {
        super(blockRoot)

        this.searcher = new SearchBox($('.searcher'))
        this.searcher.on('fullscreen:start', () => this.preventScroll())
        this.searcher.on('fullscreen:end', () => this.releaseScroll())

        this.minimizeThreshold = 300

        this.buttons = {
            open: this.root.find('.hamburger'),
            search: $('.searcher-btn'),
            arrow: this.root.find('.site-header__logo-arrow')
        }

        this.row = {
            top: this.root.find('.site-header__top-row'),
            bottom: this.root.find('.site-header__bottom-row'),
        }

        this.squeezeAllowed = true

        this.menuOpen = false
        this.maximized = true
        this.minimized = false
        this.height = this.root.outerHeight(true);

        this.scroll = {
            previous: window.pageYOffset,
            captured: window.pageYOffset,
            prevented: false,
        }

        this._bindUI()._doOnResize()._doOnScroll()
    }

    _doOnResize() {
        if (window.innerWidth >= 1024) {
            this.closeMenu()
            this.desktopBehavior()
        } else {
            this.mobileBehavior()
        }
        this.squeeze()
        return this
    }

    _doOnScroll() {
        this.squeeze()
        this.scroll.previous = window.pageYOffset
        return this
    }

    _bindUI() {
        this.buttons.search.on('click', event => {
            event.preventDefault()
            this.searcher.engageFullscreen()
        })
        this.buttons.open.on('click', event => {
            event.preventDefault()
            this.toggleMenu()
        })

        this.buttons.arrow.on('click', event => {
            $(event.target).parent().toggleClass('open')
        })

        $(window).on('scroll', event => this._doOnScroll())
        $(window).on('resize', event => this._doOnResize())
        return this
    }

    toggleMenu() {
        this.menuOpen === true ? this.closeMenu() : this.openMenu()
        return this
    }

    openMenu() {
        this.preventScroll()
        this.root.addClass('menu-open').removeClass('menu-closed')
        this.buttons.open.addClass('open')
        this.menuOpen = true
        return this
    }

    closeMenu() {
        this.root.removeClass('menu-open').addClass('menu-closed')
        this.buttons.open.removeClass('open')
        this.menuOpen = false
        this.releaseScroll()
        return this
    }

    desktopBehavior() {
        this.root.removeClass('mobile').addClass('desktop')
        $(document.body).removeClass('mobile-header').addClass('desktop-header')
        this.squeezeAllowed = true
        return this
    }

    mobileBehavior() {
        this.root.addClass('mobile').removeClass('desktop')
        $(document.body).addClass('mobile-header').removeClass('desktop-header')
        this.squeezeAllowed = false
        return this
    }

    preventScroll() {
        if (this.scroll.prevented) {
            return
        }
        this.scroll.captured = window.pageYOffset
        $(document.body).addClass('scroll-lock')
        this.scroll.prevented = true
    }

    releaseScroll() {
        if ((this.searcher.isFullscreen() && this.menuOpen) || !this.scroll.prevented) {
            return
        }
        $(document.body).removeClass('scroll-lock')
        window.scroll(0, this.scroll.captured)
        this.scroll.prevented = false
    }

    squeeze() {
        if (!this.squeezeAllowed) {
            this.root.addClass('minimized').removeClass('maximized')
            this.root.css({
                'height': this.height,
            })
            return this
        }
        if (window.pageYOffset <= this.height * 1.5) {
            this.root.css({
                'height': `${this.height - window.pageYOffset / 3}px`,
            })
            this.root.removeClass('minimized').addClass("maximized");
        } else {
            this.root.css({
                'height': `${this.height / 2}px`
            });
            this.root.addClass("minimized").removeClass("maximized");
        }
        return this;
    }
}
